import { getTelemetryInstance } from '@src/telemetry/initialize';

const DeprecationTrackingMixin = {
  inject: ['$element'],
  mounted() {
    // eslint-disable-next-line no-console
    console.log(`%c ⚠️ ${this.$options.name} has been deprecated. Checkout the deprecation guides for more information: https://designsystem.shipbob.com/?path=/story/deprecated-migration-guide--page&globals=locale:en-US`, 'color: white; background: #D22B2B; font-size: 16px; border-radius: 5px; padding: 5px;');

    try {
      getTelemetryInstance()?.trackEvent({
        name: 'DESIGN_SYSTEM_DEPRECATION_TRACKING',
        properties: {
          hostAppContainer: this.$element.getAttribute('data-sb-automation'),
          appRoot: this.$element.getAttribute('id'),
          componentName: this.$options.name,
          URL: window.location.href,
        },
      });
    } catch (error) {
      console.warn('[Design System warn] tracking deprecation error occurred: ', error);
    }
  },
};

export default DeprecationTrackingMixin;
